import { useEffect, useState } from 'react';

import { dataGridPremiumColumns } from '../../../utils/helper';

import { DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import settlementGeneratorService from '../../../service/attendanceSettlement/settlementGenerator.service';

const ProjectTable = ({ filter, checkedProjectState, buildFilter }) => {
  const { checkedProjectIds, setCheckedProjectIds } = checkedProjectState;
  const [refetchTable, setRefetchTable] = useState(false);
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'projectName', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    setRefetchTable(true);
  }, [filter]);

  const getList = (gridState) => {
    if (!filter.startDate || !filter.endDate || !filter.companyId) {
      setReports({ rows: [], rowCount: 0 });
      setRefetchTable(false);
      setCheckedProjectIds([]);
      return;
    }

    const filterItems = [
      { field: 'startDate', value: filter.startDate, operator: 'equals' },
      { field: 'endDate', value: filter.endDate, operator: 'equals' },
      { field: 'companyId', value: filter.companyId, operator: 'equals' },
    ];

    const finalFilter = buildFilter(gridState, filterItems);

    settlementGeneratorService.getProjects(finalFilter).then((data) => {
      setReports(data);
      setRefetchTable(false);
      setCheckedProjectIds(data.rows.map((item) => item.projectId));
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'projectName',
      headerName: 'Projekt neve',
      type: 'string',
      filterable: false,
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.AttendanceSettlementProjectTable}
      datagridInitialState={initialState}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      dataLoader={getList}
      rowCount={reports.rowCount}
      columns={columns}
      checkboxSelection
      disableRowSelectionOnClick
      paginationAndfilterMode="server"
      getRowId={(row) => row.projectId}
      height="400px"
      rowSelectionModel={checkedProjectIds}
      onRowSelectionModelChange={(ids) => setCheckedProjectIds(ids)}
      gridExport={true}
      headerFilters={false}
    />
  );
};

export default ProjectTable;
